import "../../css/pages/insightListing.scss";
import jsonFromDomEdit from "../modules/jsonFromDomEdit";
import { sortArrayByProp } from "../modules/util";
import accordion from "../modules/accordion";
import tabsToggle from "../modules/tabsToggle";
import BasePage from "./base";

class InsightListingPage extends BasePage {
    constructor(...opts) {
        super(...opts);
        this.insights = [];
        this.filters = {};
        this.insightsConfig = [];
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
        tabsToggle.init();
        accordion.init();

        this.insightsConfig = jsonFromDomEdit(".insights-data");
        this.insightItems = document.querySelectorAll(".insightItem");
        this.makeDropDownLists();
        this.hideItems();

        const loadMoreBtn = document.getElementById("loadMoreBtn");
        loadMoreBtn.addEventListener("click", () => this.loadMoreItems());
        this.showloadMoreBtn();
    }

    showloadMoreBtn() {
        const hiddenItemsCount = document.querySelectorAll(".insightItem.inactive").length;
        const MoreBtn = document.getElementById("loadMoreBtn");
        MoreBtn.style.display = hiddenItemsCount > 0 ? "flex" : "none";
    }

    loadMoreItems() {
        const hiddenItems = document.querySelectorAll(".insightItem.inactive");
        let count = 0;
        hiddenItems.forEach(item => {
            if (count < 18) {
                item.classList.remove("inactive");
                count++;
            }
        });

        this.showloadMoreBtn();
    }

    filterArrayByID(arr) {
        return arr.reduce((acc, current) => {
            const x = acc.find(item => item.id === current.id);
            if (!x) {
                return acc.concat([current]);
            } else {
                return acc;
            }
        }, []);
    }

    getSelectValue(el) {
        return el.options[el.selectedIndex].value;
    }

    setSelect(ops) {
        let self = this;
        let viewAll = ops.el.getAttribute("data-view-all") || "view all";

        // Filter out duplicates
        ops.optionsArray = self.filterArrayByID(ops.optionsArray);

        if (ops.optionsArray.length) {
            let optionsHTML = `<option value="">${viewAll}</option>`;
            sortArrayByProp(ops.optionsArray, "title").forEach(function(el) {
                // Filter out empty items
                if (el.id && el.title) {
                    optionsHTML = optionsHTML + `<option value="${el.id}">${el.title}</option>`;
                }
            });

            ops.el.innerHTML = optionsHTML;

            ops.el.addEventListener("change", function() {
                self.filters[ops.filterKey] = self.getSelectValue(ops.el);
                self.filterInsights();
                self.hideItems();
            });

            self.filters[ops.filterKey] = self.getSelectValue(ops.el);
        } else {
            // Hide the form section when no options
            ops.el.parentElement.style.display = "none";
        }
    }

    makeDropDownLists() {
        let self = this;

        // Setup master lists to filter by
        self.insightsConfig.insights.forEach(function(el) {
            self.insights = self.insights.concat(el.insights);
        });

        self.setSelect({
            optionsArray: self.insights,
            el: document.getElementById("insights-filter"),
            filterKey: "insights"
        });

        self.filterInsights();
    }

    filterInsights() {
        let self = this;
        let totalShown = 0;

        // Iterate through all insights
        this.insightsConfig.insights.forEach(function(locConfig) {
            let showInsight = true;
            let el = document.getElementById(locConfig.id);
            el.classList.contains("inactive") && el.classList.remove("inactive");

            Object.keys(self.filters).forEach(function(filterKey) {
                if (self.filters[filterKey] !== "") {
                    let matchFilter =
                        locConfig[filterKey] &&
                        locConfig[filterKey].some(function(elIn) {
                            return elIn.id === self.filters[filterKey];
                        });

                    if (!matchFilter) {
                        showInsight = false;
                    }
                }
            });

            if (showInsight) {
                el.classList.remove("hidden");
                totalShown++;
                totalShown > 18 && el.classList.add("inactive");
            } else {
                el.classList.add("hidden");
            }
        });
        this.showloadMoreBtn();
    }

    hideItems() {
        const container = document.querySelector(".ulInsightIn");
        var item = container.querySelectorAll("li");
        if (item.length === 0) {
            document.getElementById("titleInsightIn").setAttribute("hidden", "hidden");
        } else {
            var count = 0;
            item.forEach(valItem => {
                if (valItem.classList.value !== "insightItem insightInLi hidden") {
                    count++;
                }
            });

            if (count === 0) {
                if (document.getElementById("titleInsightIn")) document.getElementById("titleInsightIn").setAttribute("hidden", "hidden");
            } else {
                if (document.getElementById("titleInsightIn")) document.getElementById("titleInsightIn").removeAttribute("hidden");
            }
        }
    }
}

new InsightListingPage();
